import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import T, { Translate } from '../../i18n/i18n';
import { filteredTemplates, deleteTemplates, templateData, forkemplates } from '../../../services/templates';
import { editTableActions, rtcBufferActions } from '../../../redux/actions';
import { Window, Header, HeaderTitle, Background, ButtonBar, Button, ButtonSpace, TemplateWrap, TemplateHeader, TemplateFilter, TemplateTitle, TemplateList, TemplateItem, TemplateItemData, TemplateItemIcons, TemplateIconOwner, TemplateIconEditor, TemplateIconStaff, TemplateItemTitle, TemplateItemCreatedBy, NoResultTemplateList, EmptyTemplateList, ConfirmMessage } from './TemplateManager.styles';
import Keyboard from '../../../services/keyboardShortcuts';

export default () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const playerId = useSelector(state => state.authState.id);
    const selectedSheet = useSelector(state => state.charactersState.sheettemplate);
    const opened = useSelector(state => state.editTableState.openedTemplate);
    const callback = useSelector(state => state.editTableState.callbackTemplate);

    const [filter, setFilter] = useState('');
    const [allTemplateList, setAllTemplateList] = useState([]);
    const [selected, setSelected] = useState(null);
    const [canDelete, setCanDelete] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [confirmRemove, setConfirmRemove] = useState(false);

    const typingClock = useRef(null);

    const getTemplates = useCallback(async () => {
        let templates = await filteredTemplates(filter);
        setAllTemplateList(templates || []);

        setSelected(current => {
            if(templates.some(i => i.id === current)) {
                return current;
            }
            if(templates.some(i => selectedSheet && i.id === selectedSheet.id)) {
                return selectedSheet.id;
            }

            return null;
        });
    }, [filter, selectedSheet]);

    useEffect(() => {
        let item = allTemplateList.reduce((cur, acc) => (cur && cur.id === selected) ? cur : acc, null);
        if (item !== null) {
            setCanDelete(item.owner === playerId);
            setCanEdit(item.editableTo.includes(playerId) || item.owner === playerId);
        }    
    }, [allTemplateList, selected, playerId]);

    useEffect(() => {
        setSelected(selectedSheet ? selectedSheet.id : null);
        
        if (!opened || (filter && filter.length <= 2)) {
            return;
        }

        if (!filter) {
            getTemplates();
        } else {
            typingClock.current = setTimeout(async () => {
                getTemplates();
            }, 600);
        }

        let escapeKey = () => {
            dispatch(editTableActions.closeChooseTemplateWindow());
            return false;
        };

        Keyboard.register({key:'ESCAPE'}, escapeKey);
        
        return () => {
            Keyboard.unregister({key:'ESCAPE'}, escapeKey);
        }
    }, [dispatch, getTemplates, opened, selectedSheet, filter]);

    const handleFilter = (e) => {
        if (typingClock.current) {
            clearTimeout(typingClock.current);
        }
        setFilter(e.target.value);
    }

    const handleSelect = (id) => {
        let newSelected = selected === id ? null : id;
        setSelected(newSelected)

    }

    const handleRemove = () => {
        setConfirmRemove(true);
    }

    const close = () => {
        dispatch(editTableActions.closeChooseTemplateWindow());
    }



    const handleCreate = (e) => {
        history.push('/templatebuilder');
    }

    const handleEdit = () => {
        history.push(`/templatebuilder/${selected}`);
    }

    const handleFork = async (e) => {
        let req = await forkemplates(selected);
        await getTemplates();
        setSelected(req.id);
    }

    const removeSelected = async (e) => {
        await deleteTemplates(selected);
        getTemplates();
        setConfirmRemove(false);
    }

    const handleFinish = async () => {
        let selectedTemplate = {};
        selectedTemplate = await templateData(selected, true);
        dispatch(editTableActions.closeChooseTemplateWindow());
        callback(selectedTemplate);
    }


    const keyCancel = (e) => {
        e.stopPropagation();
    }

    return <div onKeyDown={keyCancel}>
        <Background className={opened ? 'opened' : ''} onClick={(e) => {close()}} />
        <Window className={opened ? 'opened' : ''}>
            <Header>
                <HeaderTitle><T value="templatemanager.title"/></HeaderTitle>
            </Header>
            <TemplateHeader>
                <TemplateTitle><T value="templatemanager.filter" /></TemplateTitle>
                <TemplateFilter value={filter} onChange={handleFilter} />
            </TemplateHeader>
            <TemplateWrap className="scrollbar">
                {(!allTemplateList || !allTemplateList.length) ? (
                    filter.length > 0 ? <NoResultTemplateList>
                        <T value="templatemanager.noresult" />
                    </NoResultTemplateList> : <EmptyTemplateList>
                        <T value="templatemanager.nofilter" />
                    </EmptyTemplateList>
                ) : null}

                {allTemplateList.length && <>
                    <TemplateList>
                        {allTemplateList.map(item => <TemplateItem onClick={() => handleSelect(item.id)} className={selected === item.id ? 'selected' : ''} key={item.id}>
                            <TemplateItemData>
                                <TemplateItemTitle>{item.name}</TemplateItemTitle>
                                <TemplateItemCreatedBy>{item.system && item.system.length ? item.system[0][Translate("lang")] : Translate("templatemanager.nosystem") } | {item.createdBy}</TemplateItemCreatedBy>
                            </TemplateItemData>
                            <TemplateItemIcons>
                                { item.owner === playerId ? <TemplateIconOwner title={Translate('templatemanager.owner')} /> : null }
                                { item.editableTo.includes(playerId) ? <TemplateIconEditor title={Translate('templatemanager.editor')} /> : null }
                                { item.staffChoice ? <TemplateIconStaff title={Translate('templatemanager.staff')} /> : null }
                            </TemplateItemIcons>
                        </TemplateItem>)}
                    </TemplateList>
                </>}
            </TemplateWrap>
            {!confirmRemove && <ButtonBar>
                {selected === null && <Button color={"#0a0"} onClick={handleCreate}><T value="templatemanager.create" /></Button>}
                {selected !== null && canDelete && <Button color={"#f33"} onClick={handleRemove}><T value="delete" /></Button>}
                {selected !== null && canEdit && <Button color={"#04f"} onClick={handleEdit}><T value="templatemanager.edit" /></Button>}
                {selected !== null && <Button color={"#3cf"} onClick={handleFork}><T value="templatemanager.fork" /></Button>}
                <ButtonSpace/>
                {selected !== null && <Button color={"#3cf"} onClick={handleFinish}><T value="templatemanager.select" /></Button>}
                <Button color={"#999"} onClick={close}><T value="templatemanager.cancel" /></Button>
            </ButtonBar>}
            {confirmRemove && selected && <ButtonBar>
                <ConfirmMessage><T value="templatemanager.confirmRemove" /></ConfirmMessage>
                <ButtonSpace/>
                <Button color={"#0c0"} onClick={() => {setConfirmRemove(false)}}><T value="no" /></Button>
                <Button color={"#f44"} onClick={() => {removeSelected()}}><T value="yes" /></Button>
            </ButtonBar>}
        </Window>
    </div>;

};